import React, { useState, useContext, useEffect } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import { Global } from "../../App";
import { FormattedMessage } from "react-intl";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import cls from "classnames";
// switch lang
import { langStringToCode } from "../../Share/Tools/switchLang";

// api
import { getOrderList } from "../../Api/staff/GetOrderInfo";
import { getAllStore } from "../../Api/staff/GetStaffInfo";

let pageTimer = {};
const RedSeconds = 60 * 5;
const GreenSeconds = 60 * 1;

function StaffReminder(props) {
  /* 宣告區塊 */
  const { globalState, dispatchGlobal } = useContext(Global);
  const [state, setState] = useState({
    isSearching: false,
    isShowBlock: true,
    dataPicker: {
      selectTime: moment().format("YYYY/MM/DD"),
    },
    dropDown: {
      toggle: false,
      selectItem: { value: 1 },
    },
    selectStore: {
      toggle: false,
      storeId: { value: 10 },
    },
    orderList: [],
    Store: [],
  });

  async function apiOrderList(storeId, langId, date, status) {
    try {
      const res = await getOrderList(storeId, langId, date, status);
      const { errCode, orderListItem } = res.data;
      if (errCode === 200) {
        return orderListItem;
      } else {
        dispatchGlobal({
          type: "UPDATE",
          payload: [{ key: "errMsg", val: errCode }],
        });
        props.history.push("/staff/error");
      }
    } catch (err) {
      console.error("OrderList error.");
      dispatchGlobal({
        type: "UPDATE",
        payload: [{ key: "errMsg", val: 418 }],
      });
      props.history.push("/staff/error");
    }
  }

  // get store
  async function apiAllStore(langId) {
    try {
      const res = await getAllStore(langId);

      const { errCode, branch } = res.data;
      if (errCode == 200) {
        const newStore = branch.map((e) => ({
          branchName: e.name,
          branchCode: e.id,
        }));
        return newStore;
      } else {
        dispatchGlobal({
          type: "UPDATE",
          payload: [{ key: "errMsg", val: errCode }],
        });
        props.history.push("/staff/error");
      }
    } catch (err) {
      console.error("all store error.");
      dispatchGlobal({
        type: "UPDATE",
        payload: [{ key: "errMsg", val: 404 }],
      });
      props.history.push("/staff/error");
    }
  }

  useEffect(() => {
    const langId = globalState.langType;
    const GetStore = async () => {
      let Store = await apiAllStore(langStringToCode(langId));
      if (Store) {
        setState((curr) => {
          return {
            ...curr,
            Store: Store,
          };
        });
      }
    };
    GetStore();
  }, [globalState.langType]);

  useEffect(() => {
    setState((curr) => {
      return {
        ...curr,
        isSearching: true,
      };
    });
    const handler = async () => {
      const storeId = state.selectStore.storeId.value;
      const langId = globalState.langType;
      const date = state.dataPicker.selectTime;

      let orderList = await apiOrderList(
        storeId,
        langStringToCode(langId),
        date,
        "1,6"
      );
      if (orderList) {
        const DateTime = new Date();
        const TotalSecond = Number(
          DateTime.getHours() * 60 * 60 +
            DateTime.getMinutes() * 60 +
            DateTime.getSeconds()
        );
        let parserOrderList = [];
        if (orderList.length > 0) {
          /* parserOrderList = orderList.map(item => ());*/
          orderList.map((item) => {
            console.log("item", item.status);
            let bAdd = false;
            let BackColor = "orangeblock";
            const CreateAt = new Date(item.createAt);
            let CreateTotal = Number(
              CreateAt.getHours() * 60 * 60 +
                CreateAt.getMinutes() * 60 +
                CreateAt.getSeconds()
            );
            switch (true) {
              case item.status === 6:
                BackColor = "perpleblock";
                break;
              case TotalSecond > CreateTotal + RedSeconds:
                BackColor = "redblock";
                break;
              case TotalSecond < CreateTotal + GreenSeconds:
                BackColor = "greenblock";
                break;
              default:
                // Default case if none of the conditions are met
                break;
            }
            // if (item.status == 1) {
            //   BackColor = "perpleblock";
            // }

            // if (TotalSecond > CreateTotal + RedSeconds) {
            //   BackColor = "redblock";
            // } else if (TotalSecond < CreateTotal + GreenSeconds) {
            //   BackColor = "greenblock";
            // }

            // 跨日搜 全紅
            if (
              new Date(state.dataPicker.selectTime) <
              new Date(
                DateTime.getFullYear(),
                DateTime.getMonth(),
                DateTime.getDate()
              )
            ) {
              BackColor = "redblock";
            }

            switch (state.dropDown.selectItem.value) {
              case 1: // 全部
                bAdd = true;
                break;
              case 2: // 全區域
                if (item.posTableNo || item.lineIntableNo) {
                  bAdd = true;
                }
                break;
              case 3: // 未入席
                if (!item.lineIntableNo) {
                  bAdd = true;
                }
                break;
              default:
                break;
            }

            if (bAdd) {
              parserOrderList.push({
                customerInfo: {
                  adult: item.adultsCount,
                  branch: item.storeName,
                  child: item.childCount,
                  country: item.countryName,
                },
                orderCode: item.orderCode,
                orderState: item.status,
                orderTime: item.createAt,
                queueNumber: item.queueNumber,
                totalPrice: item.totalPrice,
                id: item.id,
                posCode: item.posCode,
                lineIntableNo: item.lineIntable,
                posTableNo: item.posTableNo,
                isAddOrder: item.isAddOrder,
                createAt: item.createAt,
                BackColor: BackColor,
                countryName: item.countryName,
                orderExtraOption: item.orderExtraOptionList,
              });
            }
          });
        } else {
          parserOrderList = [];
        }
        setState((curr) => {
          return {
            ...curr,
            orderList: parserOrderList,
            isSearching: false,
          };
        });
      }
    };
    handler();

    let id = setInterval(() => {
      handler();
    }, 15000);
    return () => clearInterval(id);
  }, [
    globalState.langType,
    state.dropDown.selectItem,
    state.selectStore.storeId,
    state.dataPicker.selectTime,
  ]);

  function parserOrderState(orderState) {
    switch (orderState) {
      case 1:
        return {
          txt: "pages.dropDownItem.All",
          style: "",
        };
      case 2:
        return {
          txt: "pages.dropDownItem.AllArea",
          style: "",
        };
      case 3: {
        return {
          txt: "pages.dropDownItem.NoTableNo",
          style: "",
        };
      }
      default:
        throw Error(`parserOrderState error ${orderState}`);
    }
  }
  function parserStore(Store) {
    let StoreColl = state.Store.filter((e) => {
      return e.branchCode === Store;
    });
    if (StoreColl.length > 0) {
      return {
        txt: StoreColl[0].branchName,
        style: "",
      };
    } else {
      return {
        txt: "",
        style: "",
      };
    }
  }

  return (
    <div className="Pages">
      <Header props={props} />
      <div className="col d-flex flex-column align-items-center p-0 pt-3 pt-sm-0">
        <div className="Pages__section d-flex flex-column align-items-center pb-sm-4">
          <div className="Pages__title d-flex">
            <FormattedMessage
              id="header.menuItems.CheckOrderReminder"
              children={(e) => {
                const { langType } = globalState;
                if (
                  langType !== "zh" &&
                  langType !== "ja" &&
                  langType !== "ko"
                ) {
                  const splitString = e.split(" ");
                  return splitString.map((e, index) => (
                    <div
                      key={index}
                      className="pr-2 pl-2 pr-sm-3 pl-sm-3 Pages__titleChar"
                    >
                      <div>{e}</div>
                    </div>
                  ));
                } else {
                  const splitString = e.split("");
                  return splitString.map((e, index) => (
                    <div
                      key={index}
                      className="pr-2 pl-2 pr-sm-3 pl-sm-3 Pages__titleChar"
                    >
                      <div>{e}</div>
                    </div>
                  ));
                }
              }}
            />
          </div>
        </div>
        {/* filter option */}
        <div className="Pages__section Pages__list p-2 pt-sm-3 pb-sm-3">
          <div className="d-lg-flex mb-3">
            {/* store */}
            <div className="col-sm-6 col-lg-auto mb-2">
              <Dropdown
                className="Pages__dropDown"
                isOpen={state.selectStore.toggle}
                size="sm"
                style={{
                  width: globalState.device === "pc" ? "200px" : "auto",
                }}
                toggle={() =>
                  setState((curr) => {
                    let newState = { ...curr };
                    newState.selectStore.toggle = !newState.selectStore.toggle;
                    return newState;
                  })
                }
              >
                <DropdownToggle
                  caret
                  className="Pages__dropDown__button d-flex justify-content-start p-2 pr-3 pl-3"
                >
                  <span className="mr-4">
                    {parserStore(state.selectStore.storeId.value).txt}
                  </span>
                </DropdownToggle>
                <DropdownMenu className="Pages__dropDown__menu">
                  {(() => {
                    return state.Store.map((eachState, stateIndex) => (
                      <DropdownItem
                        key={stateIndex}
                        className={cls(
                          "Pages__dropDown__li p-2",
                          state.selectStore.storeId.value ===
                            eachState.branchCode
                            ? "Pages__dropDown__li_selected"
                            : ""
                        )}
                        onClick={() => {
                          setState((curr) => {
                            let newState = { ...curr };
                            newState.selectStore.storeId = {
                              value: eachState.branchCode,
                            };
                            return newState;
                          });
                        }}
                      >
                        {eachState.branchName}
                      </DropdownItem>
                    ));
                  })()}
                </DropdownMenu>
              </Dropdown>
            </div>
            <div className="d-flex mb-3">
              <div className="col-sm-6 col-lg-auto">
                <DatePicker
                  selected={moment(state.dataPicker.selectTime)._d}
                  onChange={(date) => {
                    setState((curr) => {
                      let newState = { ...curr };
                      newState.dataPicker.selectTime =
                        moment(date).format("YYYY/MM/DD");
                      return newState;
                    });
                  }}
                  minDate={moment().subtract(1, "y")._d}
                  maxDate={moment()._d}
                  customInput={
                    <div
                      className="Pages__dropDown mr-2"
                      style={{
                        width: globalState.device === "pc" ? "200px" : "auto",
                      }}
                    >
                      <div className="Pages__dropDown__button p-2 pr-3 pl-3">
                        <span className="mr-4">
                          {moment(state.dataPicker.selectTime).format(
                            "YYYY/MM/DD"
                          )}
                        </span>
                      </div>
                    </div>
                  }
                />
              </div>
              <div className="col-sm-6 col-lg-auto">
                <Dropdown
                  className="Pages__dropDown ml-2"
                  isOpen={state.dropDown.toggle}
                  size="sm"
                  style={{
                    width: globalState.device === "pc" ? "200px" : "auto",
                  }}
                  toggle={() =>
                    setState((curr) => {
                      let newState = { ...curr };
                      newState.dropDown.toggle = !newState.dropDown.toggle;
                      return newState;
                    })
                  }
                >
                  <DropdownToggle
                    caret
                    className="Pages__dropDown__button d-flex justify-content-start p-2 pr-3 pl-3"
                  >
                    <span className="mr-4">
                      {}
                      <FormattedMessage
                        id={
                          parserOrderState(state.dropDown.selectItem.value).txt
                        }
                      />
                    </span>
                  </DropdownToggle>
                  <DropdownMenu className="Pages__dropDown__menu">
                    {(() => {
                      let stateList = [
                        { value: 1 },
                        { value: 2 },
                        { value: 3 },
                      ];

                      return stateList.map((eachState, stateIndex) => (
                        <DropdownItem
                          key={stateIndex}
                          className={cls(
                            "Pages__dropDown__li p-2",
                            state.dropDown.selectItem.value === eachState.value
                              ? "Pages__dropDown__li_selected"
                              : ""
                          )}
                          onClick={() => {
                            setState((curr) => {
                              let newState = { ...curr };
                              newState.dropDown.selectItem = {
                                value: eachState.value,
                              };
                              return newState;
                            });
                          }}
                        >
                          <FormattedMessage
                            id={parserOrderState(eachState.value).txt}
                          />
                        </DropdownItem>
                      ));
                    })()}
                  </DropdownMenu>
                </Dropdown>
              </div>
            </div>
          </div>

          <div className="d-flex mb-3">
            <div className="d-flex align-items-center col-7 p-0">
              <FormattedMessage
                id="pages.staffSearchOrder.orderTotal"
                defaultMessage="共 {count} 筆"
                values={{
                  count: (
                    <span
                      className={cls(
                        state.orderList.length > 0
                          ? "text-3xl text-rose-800 mx-2"
                          : ""
                      )}
                    >
                      {state.orderList.length}
                    </span>
                  ),
                }}
              />
            </div>
          </div>
        </div>

        <div
          className={cls(
            "Order__list p-0 pt-3 pb-3 w-100",
            state.isShowBlock ? "showBlock row" : "flex-column"
          )}
        >
          {(() => {
            if (state.isSearching)
              return (
                <div
                  className="w-100 h-100 align-items-center justify-content-center"
                  style={{
                    flex: "1 1 0",
                  }}
                >
                  <FormattedMessage
                    id="staffCheckOrder.searching"
                    defaultMessage="Searching..."
                  />
                </div>
              );

            if (!state.isSearching && state.orderList.length <= 0)
              return (
                <div
                  className="w-100 h-100 align-items-center justify-content-center"
                  style={{
                    flex: "1 1 0",
                  }}
                >
                  <FormattedMessage
                    id="staffCheckOrder.dataNoFound"
                    defaultMessage="Data not found."
                  />
                </div>
              );
            {
              console.log("state.orderList", state.orderList);
            }
            return (
              <>
                {state.orderList.map((eachOrder, orderIndex) => (
                  <div
                    key={orderIndex}
                    className={cls(
                      "Pages__list p-2 pt-sm-3 pb-sm-3 col-sm-12 col-lg-6"
                    )}
                  >
                    <div className={cls(eachOrder.BackColor)}>
                      <div
                        className={cls(
                          " align-items-center mt-2 mb-2 d-flex p-4",
                          globalState.device === "pc"
                            ? ""
                            : "justify-content-between",
                          state.isShowBlock ? "justify-content-between" : ""
                        )}
                      >
                        <div className="mr-2 ">
                          <span className="ml-1 mr-1 queueNumber text-3xl">
                            {(() => {
                              const tableText =
                                globalState.langFile[
                                  "pages.staffOrderDetail.table"
                                ];
                              const addText =
                                "(" +
                                globalState.langFile["pages.all.Add"] +
                                ")";
                              // 是預點或加點
                              // 預點
                              if (eachOrder.isAddOrder === false) {
                                // 若已入席顯示桌號
                                if (eachOrder.lineIntableNo) {
                                  return (
                                    <span>
                                      {(eachOrder.lineIntableNo.slice(-1)==="桌")?eachOrder.lineIntableNo.slice(0,-1):eachOrder.lineIntableNo}
                                      <span className="ml-1">{tableText}</span>
                                    </span>
                                  );
                                } else {
                                  return globalState.langFile[
                                    "pages.all.NoTableNumber"
                                  ];
                                }
                              }
                              // 加點直接顯示pos桌號
                              if (eachOrder.isAddOrder === true) {
                                return (
                                  <span>
                                    <span className="mr-2">{addText}</span>

                                    {eachOrder.posTableNo}
                                    <span className="ml-1">{tableText}</span>
                                  </span>
                                );
                              }
                            })()}

                            <span className="ml-3">
                              {eachOrder.queueNumber}
                              {eachOrder.orderExtraOption.length > 0
                                ? eachOrder.orderExtraOption.map((e) => e.sign)
                                : ""}
                            </span>
                          </span>
                        </div>
                        <span className="ml-3 text-xl">
                          {eachOrder.countryName}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            );
          })()}
        </div>
        <div className="flex-column col p-0">
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default StaffReminder;
